import { render } from "./PartnersProfile.vue?vue&type=template&id=19fc8f2d&scoped=true"
import script from "./PartnersProfile.vue?vue&type=script&lang=js"
export * from "./PartnersProfile.vue?vue&type=script&lang=js"

import "./PartnersProfile.vue?vue&type=style&index=0&id=19fc8f2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fc8f2d"]])

export default __exports__